<template>
  <v-flex class="px-3">
    <div class="data-table-header">
      <span class="text-h6 font-weight-bold">목록 (총 {{ data.length }}개)</span>
      <v-btn class="button save" outlined @click="showAdd">게시판 추가</v-btn>
    </div>
    <v-data-table
        height="65vh"
        fixed-header
        :headers="getHeader(headers)"
        :items="data"
        :loading="loading"
        :items-per-page="-1"
        no-data-text="조회된 데이터가 없습니다"
        mobile-breakpoint="md"
    >
      <template v-slot:item.modify="{ item }">
        <v-btn class="button" outlined @click="showModify(item)">수정</v-btn>
      </template>
    </v-data-table>
    <category-add
      :is-show="isShowAdd"
      :use-role-list="useRoleList"
      @refresh="$emit('refresh')"
      @close="isShowAdd = false"
    />
    <category-modify
      :is-show="isShowModify"
      :use-role-list="useRoleList"
      :select-data="selectData"
      @refresh="$emit('refresh')"
      @close="isShowModify = false"
    />
  </v-flex>
</template>

<script>
import TableMixin from "@/mixin/TableMixin";
import {BOARD_MANAGE_TABLE} from "@/util/TableHeaders";
import DateMixin from "@/mixin/DateMixin";
import CategoryAdd from "@/pages/Board/popup/CategoryManage/CategoryAdd.vue";
import CategoryModify from "@/pages/Board/popup/CategoryManage/CategoryModify.vue";
import constant from "@/util/constant";

export default {
  name: "CategoryManageTalbe",
  components: {CategoryModify, CategoryAdd},
  props: ["data", "loading"],
  mixins: [TableMixin, DateMixin],
  data() {
    return {
      headers: BOARD_MANAGE_TABLE,
      useRoleList: constant.CATEGORY_ROLE_LIST,
      isShowAdd: false,
      isShowModify: false,
      selectData: {}
    }
  },
  mounted() {
    this.useRoleList.push({text: "팝업", value: "VIEW"});
  },
  methods: {
    showAdd() {
      this.isShowAdd = true;
    },
    showModify(item) {
      this.selectData = item;
      this.isShowModify = true;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>